import axios from "axios";
import { setServerDown, clearServerDown } from "../utils/serverStatus";

const API_BASE_URL =
  // "https://astrometric-kris-additionally.ngrok-free.dev/api";
    // "http://localhost:4000/api";
    // "http://192.168.1.50:8080/api  ";
    // "http://192.168.1.50:8080/api  ";
    // "http://210.18.189.175:8080/api";
    // "http://api2.eduforestin.com:8080/api"
    "https://api2.eduforestin.com/api";

export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 20000,
  headers: {
    "ngrok-skip-browser-warning": "true",
  },
});

 
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

 
axiosInstance.interceptors.response.use(
  (response) => {
    clearServerDown(); // ✅ server is alive
    return response;
  },
  (error) => {
    if (
      !error.response ||
      error.code === "ERR_NETWORK" ||
      error.message === "Network Error"
    ) {
      setServerDown();
   if (!error.response || error.code === "ERR_NETWORK") {
  console.log("Server unreachable");
}

    }

    return Promise.reject(error);
  }
);
